import React, { ChangeEvent } from 'react';
import { Iconfont, Input } from '@umu/umu-design';
import './index.scss';

interface PropsType {
    keyword?: string;
    className?: string;
    placeholder?: string;
    onChangeSearch: (e: ChangeEvent<HTMLInputElement>) => void;
    onSearch: () => void;
    onInputClear?: () => void;
}

function FuzzySearch(props: PropsType) {
    const { onChangeSearch, onInputClear, keyword = '', placeholder, className = '', onSearch } = props;

    const onKeyUp = (e: React.KeyboardEvent) => {
        switch (e.keyCode) {
            case 13:
                onSearch();
                break;
            default:
                break;
        }
    };

    return (
        <div className="common-fuzzy-search-container">
            <Input
                placeholder={placeholder}
                onChange={onChangeSearch}
                className={className}
                allowClear={true}
                value={keyword}
                onKeyUp={onKeyUp as any}
                onClear={onInputClear}
            />
            <div className="common-fuzzy-search-btn-container" onClick={onSearch}>
                <Iconfont type="Search" className="icon-basic" />
            </div>
        </div>
    );
}

export default FuzzySearch;
